import { request } from '@/service/request';

/** 获取当前管理员信息 */
export function getInfo() {
  return request<Entity.Me.InfoDto>({
    method: 'get',
    url: '/me'
  });
}

/** 更新当前管理员信息 */
export function updateProfile(data: Entity.Me.UpdateProfileVo) {
  return request<Entity.Me.InfoDto>({
    data,
    method: 'put',
    url: '/me/profile'
  });
}

/** 更改管理员密码 */
export function changePassword(data: Entity.Me.ChangePasswordVo) {
  return request({
    data,
    method: 'put',
    url: '/me/change-password'
  });
}
